import React, { ChangeEvent } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import {
  fetchSlotsDoctorsAsync,
  selectSlotsDepartments,
  selectSlotsSelectedDepartment,
  setSelectedSlotsDepartment,
} from '../slotsSlice'

const SelectDepartment = () => {
  const departments = useAppSelector(selectSlotsDepartments)
  const selectedDepartment = useAppSelector(selectSlotsSelectedDepartment)
  const dispatch = useAppDispatch()

  const onDepartmentChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value
    dispatch(setSelectedSlotsDepartment(value))
    dispatch(fetchSlotsDoctorsAsync(value))
  }

  return (
    <select
      className='doctorSelect'
      value={selectedDepartment}
      onChange={onDepartmentChange}
    >
      <option value=''>Select a Department</option>
      {departments?.map((department) => (
        <option key={department?.code} value={department?.display}>
          {department?.display}
        </option>
      ))}
    </select>
  )
}

export default SelectDepartment
